module.exports = __webpack_public_path__ + "static/img/schoolcoupon.46a3b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolcoupon.png
// module id = qOH5
// module chunks = 0